export default "__VITE_ASSET__Be5WnLzK__"